module.exports = __webpack_public_path__ + "static/media/AdditionsItemCalloutsExample@1x.e455b1d0634e977efc24ba264d4b49fd.jpg";